import React from 'react';
import { ButtonWrapper, StyledImportIcon, StyledInput, StyledLabel } from './styles/ImportButtonStyles';

interface IProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled: boolean;
}

export const ImportButton: React.FC<IProps> = ({ onChange, label, disabled }) => {
  return (
    <ButtonWrapper>
      <StyledInput
        type='file'
        name='file'
        id='file'
        className='input-file'
        onChange={onChange}
        onClick={(evt) => ((evt.target as HTMLInputElement).value = '')}
        disabled={disabled}
        accept='.csv'
      />
      <StyledLabel disabled={disabled} htmlFor='file'>
        <StyledImportIcon />
        {label}
      </StyledLabel>
    </ButtonWrapper>
  );
};
